// extracted by mini-css-extract-plugin
export default {"header":"Main_header__RFYuJ","trigger":"Main_trigger__MfbvZ"};